var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodOnAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 4.5H14C14 3.11929 12.8807 2 11.5 2C10.1193 2 9 3.11929 9 4.5H5.875C4.83947 4.5 4 5.33947 4 6.375V20.125C4 21.1605 4.83947 22 5.875 22H17.125C18.1605 22 19 21.1605 19 20.125V6.375C19 5.33947 18.1605 4.5 17.125 4.5ZM11.5 3.5625C12.0178 3.5625 12.4375 3.98223 12.4375 4.5C12.4375 5.01777 12.0178 5.4375 11.5 5.4375C10.9822 5.4375 10.5625 5.01777 10.5625 4.5C10.5625 3.98223 10.9822 3.5625 11.5 3.5625ZM11.5 9.5C12.8807 9.5 14 10.6193 14 12C14 13.3807 12.8807 14.5 11.5 14.5C10.1193 14.5 9 13.3807 9 12C9 10.6193 10.1193 9.5 11.5 9.5ZM15.875 18.75C15.875 19.1645 15.4844 19.5 15 19.5H8C7.51562 19.5 7.125 19.1641 7.125 18.75V18C7.125 16.7574 8.30039 15.75 9.75 15.75H9.94531C10.9412 16.1667 12.0627 16.1667 13.0586 15.75H13.2539C14.7035 15.75 15.8789 16.7574 15.8789 18L15.875 18.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodOnAccount);
export default __webpack_public_path__ + "static/media/payment-method-on-account.d568e4c9961a18d74ffa9e1f38312bd3.svg";
export { ForwardRef as ReactComponent };